module.exports = __webpack_public_path__ + "img/manutencao_logo.14be1f33.jpeg";